var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_861_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_861_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5995 14.0655C2.74049 21.8375 2.69699 21.881 2.92899 22.2145C3.05949 22.403 3.39299 22.8235 3.66849 23.1425L4.19049 23.7225L11.774 16.139L19.3575 8.56999H23.7365H28.13L27.985 8.19299C27.898 7.98999 27.666 7.46799 27.4485 7.03299L27.0715 6.24999L22.7795 6.26449H18.4875L10.5995 14.0655Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.702 17.4005L5.32147 24.781L6.32197 25.448L7.32247 26.115L14.21 19.2275L21.0975 12.34H25.056H29L28.942 12.0065C28.8985 11.8325 28.826 11.4265 28.7825 11.1075C28.594 9.91849 29.0435 10.02 24.3165 10.02H20.0825L12.702 17.4005Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2395 20.373L8.80148 26.811L9.36698 27.0575C9.67148 27.188 10.208 27.362 10.5415 27.449L11.165 27.594L14.906 23.969C16.9505 21.968 19.546 19.416 20.6625 18.2995L22.6925 16.255H25.6795C28.043 16.255 28.6955 16.2115 28.7535 16.0665C28.797 15.9505 28.8695 15.4285 28.9275 14.9065L29.029 13.935H25.3605H21.6775L15.2395 20.373Z",
    fill: "#CACACA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_861_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_861_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(0 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/PRIME.259535834306239f2d9c85cc601e6ca8.svg";
export { ForwardRef as ReactComponent };